import { render, staticRenderFns } from "./MarketingAnalysis.vue?vue&type=template&id=5b7e5aea&scoped=true&"
import script from "./MarketingAnalysis.vue?vue&type=script&lang=js&"
export * from "./MarketingAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./MarketingAnalysis.vue?vue&type=style&index=0&id=5b7e5aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7e5aea",
  null
  
)

export default component.exports